import { Route, withRouter } from 'react-router-dom';
// Router
import { routes, RouteWithSubRoutes } from './routes';
// Components
import Auth from './components/Auth';
// UI
import {

  Container,

} from '@material-ui/core';
import Sidemenu from './pages/sideMenu';
import TopBar from './components/TopBar';
import InfoLogin from './components/Layout/InfoLogin'
const Ws = (props: any) => {


  return (
    <Auth>
      <Sidemenu />
      <TopBar />
      <Container maxWidth="xl" className="sidebar-container">
        <InfoLogin />
        {routes.map((route, i) => (
          <RouteWithSubRoutes key={i} {...route} />
        ))}
      </Container>
    </Auth>
  );
};

export default withRouter(Ws);
